import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOCanvasMenuItem } from "src/app/shared/models/oo-canvas-menu-item.model";

@Component({
	selector: "app-canvas-item-included-list",
	templateUrl: "./canvas-item-included-list.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class CanvasItemIncludedListComponent implements OnInit {
	@Input() canvasKeySelected: number;
	canvasIndex: number;

	newRecord: boolean = false;

	selectedCanvasMenuItem: OOCanvasMenuItem;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {
		this.canvasIndex = this.venueSvc.ooCanvases.findIndex((canvas) => canvas.canvasKey === this.canvasKeySelected);
	}

	newItem() {
		this.selectedCanvasMenuItem = new OOCanvasMenuItem({
			canvasKey: this.venueSvc.ooCanvases[this.canvasIndex].canvasKey,
			includedItem: true,
		});
	}

	removeIncludedItem(selectedCanvasMenuItem: OOCanvasMenuItem) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to remove ${selectedCanvasMenuItem.ooMenuItem.name} from ${this.venueSvc.ooCanvases[this.canvasIndex].name}`,
			accept: async () => {
				await this.venueSvc.canvasMenuItemRemove(selectedCanvasMenuItem.menuItemKey, selectedCanvasMenuItem.canvasKey);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
